var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { MediaAsset } from 'packages/media/MediaAsset';
import { PlaceholderHelper } from 'packages/email/PlaceholderHelper';
import { container } from 'tsyringe';
var SharingSettings = /** @class */ (function (_super) {
    __extends(SharingSettings, _super);
    function SharingSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.image = null;
        _this.description = null;
        _this.keywords = null;
        _this.ogTitle = null;
        _this.ogDescription = null;
        _this.placeholderHelper = container.resolve(PlaceholderHelper);
        return _this;
    }
    Object.defineProperty(SharingSettings.prototype, "cleanTitle", {
        get: function () {
            return this.cleanTitleFromHtml(this.ogTitle);
        },
        enumerable: false,
        configurable: true
    });
    SharingSettings.prototype.toSaveRequest = function () {
        var json = this.toJson();
        json.og_title = this.cleanTitle;
        if (json.image) {
            json.image_id = json.image.id;
        }
        delete json.image;
        return json;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    SharingSettings.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (this.ogTitle) {
            this.ogTitle = this.htmlFromCleanTitle(this.ogTitle);
        }
    };
    SharingSettings.prototype.cleanTitleFromHtml = function (html) {
        return this.placeholderHelper
            .replaceElementsWithTags(html, true);
    };
    SharingSettings.prototype.htmlFromCleanTitle = function (cleanTitle) {
        return this.placeholderHelper
            .replaceTagsWithElements(cleanTitle, true);
    };
    var _a;
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_a = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _a : Object)
    ], SharingSettings.prototype, "image", void 0);
    return SharingSettings;
}(Entity));
export { SharingSettings };
